import api from "./api";
const base = "/api/planner";
export const listTasks = (params) => api.get(`${base}/tasks/`, { params });
export const getTask = (id) => api.get(`${base}/tasks/${id}/`);
export const createTask = (data) => api.post(`${base}/tasks/`, data);
export const updateTask = (id, data) => api.patch(`${base}/tasks/${id}/`, data);
export const completeTask = (id, due_date) =>
  api.post(`${base}/tasks/${id}/complete/`, { due_date });
export const deleteTask = (id) => api.delete(`${base}/tasks/${id}/`);
export const taskHistory = (id) => api.get(`${base}/tasks/${id}/history/`);
export const listPeople = () => api.get(`${base}/people/`);
export const getCalendar = (start, end) =>
  api.get(`${base}/calendar/`, { params: { start, end } });
export const getEvent = (id) => api.get(`${base}/events/${id}/`);
export const createEvent = (data) => api.post(`${base}/events/`, data);
export const updateEvent = (id, data) =>
  api.patch(`${base}/events/${id}/`, data);
export const deleteEvent = (id) => api.delete(`${base}/events/${id}/`);
export const getReminders = () => api.get(`${base}/reminders/`);
